import moment from "moment";
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const loadedLanguages = {}; // our default language that is preloaded
const DEFAULT_LANG = "en";
export const i18n = new VueI18n({
  fallbackLocale: DEFAULT_LANG,
  silentTranslationWarn: true, // hide console warn
});

const defaultSupportedLangs = {
  en: { name: "English" },
  ja: { name: "日本語" },
  // it: { name: "Italiano" },
};

const currentTarget = process.env.VUE_APP_TARGET || "ASOBI_MARKET";

// Only English for EXCHANGE app
export const supportedLangs =
  currentTarget === "EXCHANGE"
    ? { en: defaultSupportedLangs.en }
    : defaultSupportedLangs;

export function setI18nLanguage(lang) {
  i18n.locale = lang;
  moment.locale(lang);

  const htmlEl = document.querySelector("html");
  if (htmlEl) {
    htmlEl.setAttribute("lang", lang);
  }

  localStorage.setItem("lang", lang);

  return lang;
}

export const loadLanguageAsync = async (lang) => {
  if (i18n.locale === lang) {
    return lang;
  }

  if (!supportedLangs[lang]) {
    return undefined;
  }

  if (loadedLanguages[lang]) {
    return setI18nLanguage(lang);
  }

  const ret = await import(/* webpackChunkName: "lang-[request]" */ `@/frontend/lang/${lang}.json`);
  const messages = ret.default;

  i18n.setLocaleMessage(lang, messages);
  loadedLanguages[lang] = messages;

  return setI18nLanguage(lang);
};

const insertTarget = document.querySelector("link[rel=mask-icon]");
const insertLinkTagForSEO = (lang, to) => {
  const canonical: any = document.querySelector("link[rel=canonical]");
  const alternate: any = document.querySelector("link[rel=alternate]");
  const path = `${location.origin}${to.fullPath}`;
  const canonicalLink = `<link rel="canonical" href="${path}?lang=ja">`;
  const alternateLink = `<link rel="alternate" hreflang="en" href="${path}?lang=en">`;

  if (!insertTarget) {
    return;
  }

  if (alternate && lang === "en") {
    alternate.href = `${path}?lang=en`;
  } else if (!alternate && lang === "en") {
    insertTarget.insertAdjacentHTML("afterend", alternateLink);
  }

  if (canonical) {
    canonical.href = `${path}?lang=ja`;
  } else {
    insertTarget.insertAdjacentHTML("afterend", canonicalLink);
  }
};

let lastLang;

export const initI18nRouter = (router) => {
  router.beforeEach(async (to, from, next) => {
    const ln = 2;
    let lang =
      to.query.lang ||
      localStorage.getItem("lang") ||
      navigator.language.substr(0, ln) ||
      "DEFAULT_LANG";

    lang = supportedLangs[lang] ? lang : DEFAULT_LANG;

    insertLinkTagForSEO(lang, to);

    await loadLanguageAsync(lang);

    if (lastLang && lastLang !== lang) {
      location.reload();
    }
    lastLang = lang;

    next();
  });
};
